import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { StepJSONAModel } from "interfaces/jsona-models/StepJSONAModel";

export class StepSelector extends BaseApiSelector<StepJSONAModel> {
  constructor() {
    super(ResourceType.Step);
  }
}
